<template>
  <div class="explore-services-box-group">
    <div class="box-container">
      <router-link :to="`/${$i18n.locale}/services?type=0`" class="item order-1">Company Incorporation<fa-icon class="icon" :icon="['fas', 'long-arrow-alt-right']" color="white"/></router-link>
      <router-link :to="`/${$i18n.locale}/services?type=2`" class="item order-3 order-lg-2">Tax<fa-icon class="icon" :icon="['fas', 'long-arrow-alt-right']" color="white"/></router-link>
      <router-link :to="`/${$i18n.locale}/services?type=4`" class="item order-5 order-lg-3">Payroll Processing<fa-icon class="icon" :icon="['fas', 'long-arrow-alt-right']" color="white"/></router-link>
      <router-link :to="`/${$i18n.locale}/services?type=1`" class="item order-2 order-lg-4">Company Secretarial<fa-icon class="icon" :icon="['fas', 'long-arrow-alt-right']" color="white"/></router-link>
      <router-link :to="`/${$i18n.locale}/services?type=5`" class="item order-4 order-lg-5">Training<fa-icon class="icon" :icon="['fas', 'long-arrow-alt-right']" color="white"/></router-link>
      <router-link :to="`/${$i18n.locale}/services?type=3`" class="item order-6">Employer Registration<fa-icon class="icon" :icon="['fas', 'long-arrow-alt-right']" color="white"/></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'services-box',
  data: function () {
    return {

    }
  },
  props: {
    // content: {
    //   type: String,
    //   required: true,
    //   default: ''
    // }
  },
  computed: {
  },
  created () {
  },
  destroyed () {
  },
  methods: {
    // navigate () {
    //   this.$router.push(`/${this.$i18n.locale}/services?type=training`)
    // }
  }
}
</script>
